import { UIComponentProps, UIComponentHandler, UIComponentState, UIComponentImpl, UIDataModel } from '../../toolkit/uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../../toolkit/uicomponentview';
import { PopUpWrapperViewImpl } from './popupwrapperview';
import { UIComponentCSSStyle } from '../../toolkit/uicomponentcss';
import { PopUpWrapperCSSStyleImpl } from './popupwrappercss';
import * as React from 'react';

export interface PopUpWrapperComponentProps extends UIComponentProps
{
//    onSuccess(popupMsg:string):void;
//    onFailure(popupMsg:string):void;
}

export interface PopUpWrapperComponentHandler extends UIComponentHandler
{
    
}

export interface PopUpWrapperComponentState extends UIComponentState
{
    childComponent: JSX.Element;
    isShowWindow: boolean;

}

export class PopUpWrapperComponent extends UIComponentImpl<PopUpWrapperComponentProps, PopUpWrapperComponentState, UIDataModel> implements PopUpWrapperComponentHandler
{
    constructor(props: PopUpWrapperComponentProps)
    {
        super(props);

        this.state = {isShowWindow: false, childComponent: <></>};
    }

    componentDidMount()
    {
        window.scrollTo(0,100);
    }
    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        this.setWidth("440px");
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PopUpWrapperViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new PopUpWrapperCSSStyleImpl(applicationContext);
    }

    setWidth(width: string)
    {
        // (this.getStyle() as PopUpWrapperCSSStyleImpl).setChildComponentWidth(width);
    }

    setShowWindow(isShow: boolean, childComponent: JSX.Element)
    {
        if(isShow){
            let body = document.getElementById("body-id");
            if(body){
                body.style.overflow = 'hidden';
            }
        }else
        {
            this.setWidth("440px");

            let body = document.getElementById("body-id");
            if(body){
                body.style.overflow = 'auto';
            }
        }
        this.setState({isShowWindow: isShow, childComponent: childComponent});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/popupwrappercomponent.tsx